import { MapRoot } from "./Map.styles";
import Iframe from "../Iframe/Iframe";
import clsx from "clsx";
import { IframeProps } from "../Iframe/Iframe.types";

export interface MapProps extends IframeProps {}

function MapComponent({ className, style, ...rest }: MapProps) {
    return (
        <MapRoot data-testid="map" style={style} className={clsx(className, "map")}>
            <Iframe {...rest} />
        </MapRoot>
    );
}

export default MapComponent;
